(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("antd"), require("React"), require("loadjs"), require("ecCom"), require("jQuery"), require("ReactDOM"), require("$"));
	else if(typeof define === 'function' && define.amd)
		define(["antd", "React", "loadjs", "ecCom", "jQuery", "ReactDOM", "$"], factory);
	else if(typeof exports === 'object')
		exports["ecCom"] = factory(require("antd"), require("React"), require("loadjs"), require("ecCom"), require("jQuery"), require("ReactDOM"), require("$"));
	else
		root["ecCom"] = factory(root["antd"], root["React"], root["loadjs"], root["ecCom"], root["jQuery"], root["ReactDOM"], root["$"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_54__, __WEBPACK_EXTERNAL_MODULE_753__, __WEBPACK_EXTERNAL_MODULE_507__, __WEBPACK_EXTERNAL_MODULE_38__, __WEBPACK_EXTERNAL_MODULE_196__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition